// IncidentResponsePlaybookContext.tsx
import React, {
  createContext,
  useContext,
  useState,
  PropsWithChildren,
} from "react";

// Define the interface for context values
interface IncidentResponsePlaybookContextType {
  selectedIncidentResponsePlaybook: any;
  setSelectedIncidentResponsePlaybook: React.Dispatch<
    React.SetStateAction<any>
  >;
  playbookDetails: any;
  setPlaybookDetails: React.Dispatch<React.SetStateAction<any>>;
}

// Create context with initial values
const IncidentResponsePlaybookContext = createContext<
  IncidentResponsePlaybookContextType | undefined
>(undefined);

// Create a provider component to wrap your app
export const IncidentResponsePlaybookProvider = ({
  children,
}: PropsWithChildren<{}>) => {
  const [
    selectedIncidentResponsePlaybook,
    setSelectedIncidentResponsePlaybook,
  ] = useState<any>({});
  const [playbookDetails, setPlaybookDetails] = useState<any>({});

  return (
    <IncidentResponsePlaybookContext.Provider
      value={{
        selectedIncidentResponsePlaybook,
        setSelectedIncidentResponsePlaybook,
        playbookDetails,
        setPlaybookDetails,
      }}
    >
      {children}
    </IncidentResponsePlaybookContext.Provider>
  );
};

// Create a custom hook for using IncidentResponsePlaybookContext
export const useIncidentResponsePlaybookContext = () => {
  const context = useContext(IncidentResponsePlaybookContext);
  if (!context) {
    throw new Error(
      "useIncidentResponsePlaybookContext must be used within a IncidentResponsePlaybookProvider"
    );
  }
  return context;
};

export default IncidentResponsePlaybookContext;
